var map = {
	"./bretzel-games.png": "b331",
	"./esdi.png": "4588",
	"./gamejam.gif": "036d",
	"./gogoresto.png": "c9d4",
	"./graal.png": "f1cb",
	"./havas-voyages.jpeg": "1f40",
	"./kamisado.jpg": "4fce",
	"./logo_expandia.svg": "a7ee",
	"./logo_syncodeo.svg": "c444",
	"./moi.webp": "7d6d",
	"./nura.png": "4e31",
	"./pim.png": "a9e8",
	"./preppy.webp": "f7c1",
	"./qrcode.png": "6cd8",
	"./snake.jpeg": "fd58",
	"./zestfully.png": "570f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "35ef";